import * as React from "react";
import { cn } from "../../utils/helpers";

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
    options: Array<{ value: string; label: string }> | string[];
    className?: string;
}


const Select = React.forwardRef<HTMLSelectElement, SelectProps>(({ options, className, ...props }, ref) => {
    return (
        <div style={{ position: 'relative', width: '100%' }}>
            <select
                ref={ref}
                className={cn(
                    "flex h-9 w-full items-center rounded-md border border-input bg-background px-3 py-2 text-sm text-foreground shadow-sm ring-offset-background focus:outline-none focus:ring-1 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50 appearance-none pr-8",
                    className
                )}
                style={{
                    MozAppearance: 'none',
                    WebkitAppearance: 'none',
                    appearance: 'none',
                } as React.CSSProperties}
                {...props}
            >
                {Array.isArray(options) && typeof options[0] === "object"
                    ? (options as Array<{ value: string; label: string }>).map((opt, idx) => (
                        <option
                            key={opt.value}
                            value={opt.value}
                            className={cn("bg-background text-foreground", idx === 0 && "text-muted-foreground")}
                        >
                            {opt.label}
                        </option>
                    ))
                    : (options as string[]).map((opt, idx) => (
                        <option
                            key={opt}
                            value={opt}
                            className={cn("bg-background text-foreground", idx === 0 && "text-muted-foreground")}
                        >
                            {opt}
                        </option>
                    ))}
            </select>
            <svg
                style={{
                    pointerEvents: 'none',
                    position: 'absolute',
                    right: '1rem',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: '1em',
                    height: '1em',
                    opacity: 0.5,
                }}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <polyline points="6 9 12 15 18 9" />
            </svg>
        </div>
    );
});

Select.displayName = "Select";

export { Select };